<template>
  <div class="wrap">
    <div
      class="header-block"
      ref="headerBlock"
      :class="{ homeCss: this.$route.path === '/home/homePage' }"
    >
      <van-swipe :autoplay="3000" lazy-render>
        <van-swipe-item v-for="(item, index) in banners" :key="index">
          <div class="adBlock">
            <a :href="item.href">
              <img :src="item.url" alt="banner">
            </a>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div
        class="header"
        v-if="
          this.$route.path !== '/myOrder/orderAdmin' &&
            this.$route.path !== '/orderDetail' &&
            this.$route.path !== '/product/library' &&
            this.$route.path !== '/setting/recharge' &&
            this.$route.path !== '/productLibraryDetail' &&
            this.$route.path !== '/setting/tradingRecord' &&
            this.$route.path !== '/tradingRecordDetail' &&
            this.$route.path !== '/gallery/myGallery' &&
            this.$route.path !== '/gallery/openGallery' &&
            this.$route.path !== '/gallery/singleGallery' &&
            this.$route.path !== '/imgDetailOpen' &&
            this.$route.path !== '/imgDetailSingle' &&
            this.$route.path !== '/imgDetailMy' &&
            this.$route.path !== '/main/cart' &&
            this.$route.path !== '/main/cartCheckout' &&
            this.$route.path !== '/myOrder/orderPay' &&
            this.$route.path !== '/orderFBA/orderAdmin' &&
            this.$route.path !== '/setting/payWait'
        "
      >
        <span class="logo" @click="$router.push('/home')"></span>
        <div
          class="input"
          v-if="this.$route.path !== '/views/main' && this.$route.path !== '/goods/library'"
        >
          <input type="text" placeholder="产品名称" v-model="name">
          <van-icon name="search" size="16" @click="search"/>
        </div>
        <div class="router-box">
          <div v-if="this.$route.path == '/views/main'" class="router-tit">工作台</div>
          <span class="icon" @click="show = true"></span>
          <!-- <img src="@/assets/header/icons.png" alt="" class="icon" /> -->
        </div>
      </div>
      <div v-if="this.$route.path === '/orderDetail'">
        <van-nav-bar title left-arrow @click-left="onClickLeft">
          <template #left>
            <img class="left-tit-img" src="@/assets/myOrder/left-icon.png" alt>
            <span class="left-tit-sp">订单详情</span>
          </template>
          <template #right>
            <span
              class="tag-read"
              :data-clipboard-text="getOrderDetail.third_order_id"
              @click="copyFn"
              style="color: #1989fa"
            >复制订单号</span>
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path == '/myOrder/orderAdmin'">
        <van-nav-bar
          title
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 我的订单
          </template>
        </van-nav-bar>
        <div class="search-box flex-box">
          <div
            class="flex-box all"
            :class="{ on: chooseType === -1 }"
            @click="
              () => {
                chooseType = -1
                $store.commit('change')
                $store.commit('stateChange', '')
              }
            "
          >
            全部
            <img src="@/assets/myOrder/sj-icon.png" alt>
          </div>
          <div class="nav-btn-box">
            <div class="cs-wrap">
              <div class="cs-h">
                <div class="cs-sroll">
                  <div
                    class="cs-item"
                    v-for="(item, i) in orderTypeDate"
                    :key="i"
                    :class="{ on: chooseType === i }"
                    @click=";(chooseType = i), $store.commit('stateChange', i + 1)"
                  >{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.$route.path == '/orderFBA/orderAdmin'">
        <van-nav-bar
          title
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> FBA订单
          </template>
        </van-nav-bar>
        <div class="search-box flex-box">
          <div
            class="flex-box all"
            :class="{ on: FBAchooseType === -1 }"
            @click="
              () => {
                FBAchooseType = -1
                $store.commit('change')
                $store.commit('fbaStateChange', '')
              }
            "
          >
            全部
            <img src="@/assets/myOrder/sj-icon.png" alt>
          </div>
          <div class="nav-btn-box">
            <div class="cs-wrap">
              <div class="cs-h">
                <div class="cs-sroll">
                  <div
                    class="cs-item"
                    v-for="(item, i) in orderTypeDate"
                    :key="i"
                    :class="{ on: FBAchooseType === i }"
                    @click=";(FBAchooseType = i), $store.commit('fbaStateChange', i + 1)"
                  >{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="this.$route.path == '/orderFBA/orderAdmin'">
        <van-nav-bar
          title=""
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left> <img @click="show = true" src="@/assets/main/shu-icon.png" alt="" /> FBA订单 </template>
        </van-nav-bar>
        <div class="search-box flex-box">
          <div
            class="flex-box all"
            :class="{ on: FBAchooseType === -1 }"
            @click="
              () => {
                FBAchooseType = -1
                $store.commit('change')
                $store.commit('fbaStateChange', '')
              }
            "
          >
            全部 <img src="@/assets/myOrder/sj-icon.png" alt="" />
          </div>
          <div class="nav-btn-box">
            <div class="cs-wrap">
              <div class="cs-h">
                <div class="cs-sroll">
                  <div
                    class="cs-item"
                    v-for="(item, i) in statusMap"
                    :key="i"
                    :class="{ on: FBAchooseType === i }"
                    @click=";(FBAchooseType = i), $store.commit('fbaStateChange', i + 1)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!-- <div v-if="this.$route.path == '/orderFBA/orderAdmin'">
        <van-nav-bar
          title=""
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left> <img @click="show = true" src="@/assets/main/shu-icon.png" alt="" /> FBA订单 </template>
        </van-nav-bar>
      </div>-->
      <div v-if="this.$route.path == '/product/library'">
        <van-nav-bar
          title
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 产品库
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path == '/main/cart'">
        <van-nav-bar
          title
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt>
            购物车({{ total_item_num }})
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path == '/main/cartCheckout'">
        <van-nav-bar title class="myOrder-nav" @click-right="$store.commit('changeEdit')">
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 核对订单信息
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path == '/myOrder/orderPay'">
        <van-nav-bar title class="myOrder-nav">
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 订单货款
          </template>
        </van-nav-bar>
      </div>
      <div
        v-if="
          this.$route.path == '/gallery/myGallery' ||
            this.$route.path == '/gallery/openGallery' ||
            this.$route.path == '/gallery/singleGallery'
        "
      >
        <van-nav-bar
          title
          :right-text="edit ? '取消' : '编辑'"
          class="myOrder-nav"
          @click-right="$store.commit('changeEdit')"
        >
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 素材库
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path === '/setting/recharge'">
        <van-nav-bar title left-arrow @click-left="onClickLeft">
          <template #left>
            <img class="left-tit-img" src="@/assets/myOrder/left-icon.png" alt>
            <span class="left-tit-sp">账号充值</span>
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path === '/productLibraryDetail'">
        <van-nav-bar title left-arrow @click-left="onClickLeft">
          <template #left>
            <img class="left-tit-img" src="@/assets/myOrder/left-icon.png" alt>
            <span class="left-tit-sp">产品详情</span>
          </template>
        </van-nav-bar>
      </div>
      <div
        v-if="
          this.$route.path == '/imgDetailOpen' ||
            this.$route.path == '/imgDetailSingle' ||
            this.$route.path == '/imgDetailMy'
        "
      >
        <van-nav-bar title left-arrow @click-left="onClickLeft">
          <template #left>
            <img class="left-tit-img" src="@/assets/myOrder/left-icon.png" alt>
            <span class="left-tit-sp">图片详情</span>
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path == '/setting/tradingRecord'">
        <van-nav-bar title class="myOrder-nav" @click-right="$store.commit('changeEdit')">
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 交易记录
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path == '/setting/payWait'">
        <van-nav-bar title class="myOrder-nav" @click-right="$store.commit('changeEdit')">
          <template #left>
            <img @click="show = true" src="@/assets/main/shu-icon.png" alt> 待支付账款
          </template>
        </van-nav-bar>
      </div>
      <div v-if="this.$route.path === '/tradingRecordDetail'">
        <van-nav-bar title left-arrow @click-left="onClickLeft">
          <template #left>
            <img class="left-tit-img" src="@/assets/myOrder/left-icon.png" alt>
            <span class="left-tit-sp">记录详情</span>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <van-popup
      v-model="show"
      position="right"
      :style="{ height: '100%', width: '230px' }"
      closeable
    >
      <div class="popupSlot" :style="{ paddingTop: `${fixBlockHeight + 25}px` }">
        <div class="menu" v-for="(menu, index) in menuData" :key="index" @click="goRouter(menu)">
          <span class="title" :style="{ color: activeMenu === menu.title ? '#1890FF' : '#666666' }">
            {{
            menu.title
            }}
          </span>
          <van-divider v-if="menu !== '商学院'"/>
        </div>
        <div class="menu">
          <a @click="goRouter({ path: '/home/blog' })">
            <span class="title">博客</span>
          </a>
          <van-divider/>
        </div>
        <template v-if="token">
          <div class="menu work">
            <span
              class="title"
              :style="{ color: activeMenu === '工作台' ? '#1890FF' : '#666666' }"
              @click="goRouter({ path: '/views/main' })"
            >工作台</span>
            <img
              src="@/assets/main/xl-icon.png"
              alt
              :class="{ rotates: menuShow }"
              @click="menuShow = !menuShow"
            >
          </div>
          <div v-if="menuShow">
            <div v-for="(item, index) in sonMenu" :key="index">
              <div class="menu myOrder-tit" @click="goRouter({ path: item.path })">
                <span class="title" :class="{ on: activeMenu == item.name }">{{ item.name }}</span>
              </div>
              <van-divider class="menu-divider" v-if="index != sonMenu.length - 1"/>
            </div>
          </div>
        </template>
        <div class="login">
          <van-button @click="login" v-if="!token">登录/注册</van-button>
          <van-button @click="loginout" v-else>退出登录</van-button>
        </div>
      </div>
    </van-popup>
    <router-view
      class="routerView"
      :style="{ paddingTop: `${fixBlockHeight}px` }"
      id="wrap"
      @change="change"
    ></router-view>
    <div
      class="bottom"
      v-if="
        this.$route.path !== '/imgDetailOpen' &&
          this.$route.path !== '/imgDetailSingle' &&
          this.$route.path !== '/imgDetailMy' &&
          this.$route.path !== '/main/cart' &&
          this.$route.path !== '/main/cartCheckout' &&
          this.$route.path !== '/myOrder/orderPay' &&
          this.$route.path !== '/orderFBA/orderAdmin' &&
          this.$route.path !== '/home/blog'
      "
    >
      <div class="abuotUs">
        <van-popover
          trigger="click"
          v-model="showPopover"
          :actions="actions"
          placement="top"
          @select="onSelect"
        >
          <template #reference>
            <span style="color:#1890FF">关于我们</span>
          </template>
        </van-popover>
        <span>|</span>
        <span>加入我们</span>
        <span>|</span>
        <span>新手指南</span>
        <span>|</span>
        <span>售后服务</span>
      </div>
      <div class="email">
        <div>
          <span class="title">招商部邮箱:</span>
          <span class="url">bussiness@S2bDiy.com</span>
        </div>
        <div>
          <span class="title">客服部邮箱:</span>
          <span class="url">customerservice@S2bDiy.com</span>
        </div>
        <!-- <div>
          <span class="title">联系电话:</span>
          <span class="url">0591-88002666</span>
        </div>-->
      </div>
      <div class="qcode">
        <img src="@/assets/header/goTop.png" alt class="gotop" @click="gotop" v-if="showTop">
        <div>
          <img src="@/assets/home/hwKf.png" alt>
          <p>海外产品专属客服</p>
        </div>
        <div>
          <img src="@/assets/home/bt_er.png" alt>
          <p>国内发货专属客服</p>
        </div>
        <div>
          <img src="@/assets/home/qrcode.jpg" alt>
          <p>扫码关注公众号</p>
        </div>
      </div>
      <p class="copyright" style="margin-top:14px">2020-2025 S2BDIY供应链 版权所有</p>
      <p class="copyright">经营许可证编号：闽B2-20201305 | 闽ICP备20010771号-1</p>
      <div class="iwantyou" v-if="activeMenu === '商学院'" @click="iwant">我要报名</div>
    </div>
    <Report ref="Report" @change="reportChange"/>
    <Success ref="Success" @close="closeAll"/>
    <Register ref="Register"/>
    <div class="screenSidebarFix" id="screenSidebarFix"></div>
    <div class="dateWrap" id="dateWrap"></div>
  </div>
</template>
<script>
import "./style/index.less"
import Clipboard from "clipboard"
import Report from "@/views/signUp/index1.vue"
import Success from "@/views/signUp/index.vue"
import Register from "@/views/register"
import { mapMutations, mapState, mapGetters } from "vuex"
import { logout } from "@/api/home"
import { statusMap } from "@/utils/const"
export default {
  name: "App",
  data() {
    return {
      banners: [
        {
          url: require("@/assets/home/ad_1.png"),
          href: "/home/userWelfare"
        },
        {
          url: require("@/assets/home/ad_2.jpg"),
          href: "/goods/library?noCn=1"
        }
      ],
      urlImg: require("@/assets/home/ad_1.png"),
      fixBlockHeight: 60,
      name: "",
      menuShow: false,
      showPopover: false,
      actions: [{ text: "公司简介" }, { text: "服务条款" }, { text: "定制模式" }, { text: "关于我们" }],
      show: false,
      menuData: [
        { title: "首页", path: "/home" },
        { title: "商品列表", path: "/goods/library" },
        { title: "会员服务", path: "/home/vipService" }
        // { title: "商学院", path: "/home/college" }
      ],
      activeMenu: "首页",
      showTop: false,
      chooseType: -1,
      FBAchooseType: -1,
      orderTypeDate: [
        { name: "未确认", id: 1 },
        { name: "未付款", id: 2 },
        { name: "审核中", id: 3 },
        { name: "排单中", id: 4 },
        { name: "生产中", id: 5 },
        { name: "已发货", id: 6 },
        { name: "已取消", id: 7 },
        { name: "派单异常", id: 8 },
        { name: "生产异常", id: 9 },
        { name: "运单生成异常", id: 10 },
        { name: "发货异常", id: 11 }
      ],
      statusMap: statusMap,
      sonMenu: [
        { name: "产品库", path: "/product/library" },
        { name: "订单管理", path: "/myOrder/orderAdmin" },
        { name: "FBA订单", path: "/orderFBA/orderAdmin" },
        { name: "购物车", path: "/main/cart" }
      ]
    }
  },
  watch: {
    $route() {
      this.activeMenu = this.$route.meta.title
    },
    states() {
      this.chooseType = this.states - 1
    },
    fbaStates() {
      this.FBAchooseType = this.fbaStates - 1
    }
  },
  computed: {
    ...mapState({
      token: state => state.user.token,
      allshow: state => state.order.allshow,
      edit: state => state.order.edit,
      states: state => state.order.states,
      fbaStates: state => state.order.fbaStates,
      total_item_num: state => state.cart.total_item_num
    }),
    ...mapGetters(["getOrderDetail"])
  },
  components: { Report, Success, Register },
  methods: {
    resizeFn() {
      var newImg = new Image()
      newImg.src = this.urlImg
      newImg.onload = () => {
        this.$nextTick(() => {
          const { headerBlock } = this.$refs
          this.fixBlockHeight = headerBlock.offsetHeight
        })
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    copyFn() {
      var clipboard = new Clipboard(".tag-read")
      clipboard.on("success", () => {
        this.$notify({
          type: "success",
          message: "复制成功"
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on("error", () => {
        // 不支持复制
        this.$notify({
          type: "error",
          message: "该浏览器不支持自动复制"
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    change(data) {
      // console.log("roterviewChange", data)
      this.$refs.Register.show = data
    },
    ...mapMutations({
      removeToken: "REMOVE_TOKEN",
      setToPath: "SET_TO_PATH"
    }),
    loginout() {
      logout().then(() => {
        this.removeToken()
        this.show = false
        location.reload()
      })
    },
    search() {
      this.$router.push({
        path: "/goods/library",
        query: {
          name: this.name
        }
      })
    },
    login() {
      this.$refs.Register.show = true
      this.show = false
    },
    closeAll() {
      this.$refs.Report.show = false
    },
    reportChange() {
      const { Success } = this.$refs
      Success.show = true
      this.$nextTick(() => {
        Success.countDown()
      })
    },
    onSelect(index) {
      console.log(index)
    },
    goRouter(menu) {
      this.$router.push(menu.path)
      this.show = false
    },
    iwant() {
      if (this.token) {
        this.$refs.Report.show = true
      } else {
        alert(1)
        this.setToPath("/home/college")
        this.$refs.Register.show = true
      }
    },
    gotop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    getPageScroll() {
      const top = document.documentElement.scrollTop
      const { height } = document.body.getBoundingClientRect()
      if (top > height) {
        this.showTop = true
      } else {
        this.showTop = false
      }
    }
  },
  mounted() {
    this.activeMenu = this.$route.meta.title
    window.onscroll = this.getPageScroll
    this.resizeFn()
  }
}
</script>
<style lang="less" scoped>
html,
body {
  position: relative;
}
.header-block {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 2222;
  .adBlock {
    font-size: 0;
    img {
      width: 100%;
    }
  }
  .left-tit-img {
    width: 10px;
    margin-right: 6px;
  }
  .left-tit-sp {
    font-size: 18px;
    color: #000;
  }
  &.homeCss {
    background: #1771f8;
    .logo {
      height: 32px;
      width: 110px;
      background: url("../assets/header/logo_white.png") center center no-repeat;
      background-size: 110px auto;
    }
    .icon {
      height: 24px;
      width: 24px;
      background: url("../assets/header/icons_on.png") center center no-repeat;
      background-size: cover;
    }
  }
}
.routerView {
  // padding-top: 60px;
  min-height: calc(100% - 314px);
  box-sizing: border-box;
}
.wrap {
  height: 100%;
}
.header {
  // padding: 14px;
  padding: 0 14px;
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  .router-box {
    display: flex;
    align-items: center;
    .router-tit {
      font-size: 15px;
      margin-right: 10px;
    }
  }
  .logo {
    height: 32px;
    width: 110px;
    background: url("../assets/header/logo_blank.png") center center no-repeat;
    background-size: 110px auto;
  }
  .icon {
    height: 24px;
    width: 24px;
    background: url("../assets/header/icons.png") center center no-repeat;
    background-size: cover;
  }
  .input {
    height: 32px;
    display: flex;
    align-items: center;
    width: 175px;
    border: 1px solid #cccccc;
    border-radius: 5px;
    padding: 0 12px;
    box-sizing: border-box;
    background: #fff;
    input {
      width: 130px;
      height: 16px;
      border: none;
      font-size: 12px;
    }
  }
}
.popupSlot {
  padding-top: 85px;
  padding-left: 30px;
  padding-right: 20px;
  .title {
    font-size: 16px;
    color: #666666;
  }
  .login {
    padding-top: 120px;
    text-align: center;
  }
}
.bottom {
  box-sizing: border-box;
  height: 314px;
  background: #1a2025;
  position: relative;
  padding: 18px;
  .abuotUs {
    height: 21px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: white;
  }
  .email {
    margin-top: 16px;
    div {
      height: 26px;
      font-size: 14px;
      padding-left: 10px;
      .title {
        color: #999999;
      }
      .url {
        color: #1890ff;
      }
    }
  }
  .qcode {
    position: relative;
    margin-top: 16px;
    display: flex;
    padding: 0 16px;
    justify-content: space-around;
    .gotop {
      position: fixed;
      bottom: 65px;
      right: 24px;
      height: 32px;
      width: 32px;
    }
    div {
      text-align: center;
      img {
        height: 80px;
        width: 80px;
      }
      p {
        margin: 0;
        font-size: 12px;
        color: #666666;
        text-align: center;
      }
    }
  }
  .copyright {
    text-align: center;
    margin: 0;
    color: #666666;
    font-size: 12px;
  }
  .iwantyou {
    height: 60px;
    background: #10239e;
    text-align: center;
    font-size: 16px;
    color: white;
    line-height: 60px;
    position: fixed;
    width: 375px;
    bottom: 0;
    left: 0;
  }
}
.screenSidebarFix {
  position: relative;
  z-index: 3333;
}
.dateWrap {
  position: relative;
  z-index: 3335;
}
.work {
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 8px;
    height: 4px;
  }
  .rotates {
    transform: rotateZ(180deg);
  }
}
.myOrder-tit {
  margin-left: 18px;
  height: 30px;
  line-height: 30px;
  // display: flex;
  // align-items: center;
  .on {
    color: #1890ff;
  }
}
</style>
